const HATCH_ID = 'faq-doodle-hatch';
const HOOK_PATH =
  'M55 55 C55 22 95 8 138 18 C175 27 192 58 174 90 C163 110 138 112 120 132 L120 168';

const GROUND_HATCH = Array.from({ length: 9 }, (_, i) => {
  const x = 46 + i * 16;
  return { x1: x, y1: 276, x2: x + 16, y2: 262 };
});

export function QuestionMarkDoodle() {
  return (
    <svg
      className="landing-faq__doodle"
      viewBox="0 0 220 300"
      fill="none"
      aria-hidden="true"
    >
      <defs>
        <pattern
          id={HATCH_ID}
          width="7"
          height="7"
          patternTransform="rotate(45)"
          patternUnits="userSpaceOnUse"
        >
          <rect width="7" height="7" fill="#fff" />
          <line
            x1="0"
            y1="0"
            x2="0"
            y2="7"
            stroke="#1d1d1f"
            strokeWidth="1.6"
          />
        </pattern>
      </defs>

      <path
        d={HOOK_PATH}
        transform="translate(9 9)"
        stroke="#1d1d1f"
        strokeWidth="33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d={HOOK_PATH}
        transform="translate(9 9)"
        stroke={`url(#${HATCH_ID})`}
        strokeWidth="29"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d={HOOK_PATH}
        stroke="#1d1d1f"
        strokeWidth="33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d={HOOK_PATH}
        stroke="#fff"
        strokeWidth="29"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <polygon
        points="100,210 140,210 160,195 120,195"
        fill="#fff"
        stroke="#1d1d1f"
        strokeWidth="4"
      />
      <polygon
        points="140,210 160,195 160,235 140,250"
        fill={`url(#${HATCH_ID})`}
        stroke="#1d1d1f"
        strokeWidth="4"
      />
      <polygon
        points="100,210 140,210 140,250 100,250"
        fill="#fff"
        stroke="#1d1d1f"
        strokeWidth="4"
      />

      <g stroke="#1d1d1f" strokeWidth="2.5" strokeLinecap="round">
        {GROUND_HATCH.map((l, i) => (
          <line key={i} x1={l.x1} y1={l.y1} x2={l.x2} y2={l.y2} />
        ))}
      </g>
    </svg>
  );
}
